<template>
  <div>
    <modal
      name="modal--login"
      transition="nice-modal-fade"
      :click-to-close="false"
      :width="350"
      :height="'auto'"
    >
      <div
        class="flex flex-col font-degular text-black h-full bg-white overflow-hidden w-full justify-between p-4 rounded-lg"
      >
        <img
          class="p-2 w-full h-full"
          style="object-fit: contain"
          src="@/assets/svg/SLS-PrimaryHoriz-Fire.svg"
          alt="Fire Logo"
        />
        <form @submit.prevent="handleSubmit" autocomplete="off">
          <label
            class="mt-6 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Email
            <input
              type="text"
              ref="username"
              class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
              :class="{ 'invalid-input': invalidUsername }"
              @input="invalidUsername = false"
              placeholder="jill@seoulspice.com"
              v-model="username"
            />
          </label>
          <p
            :class="{ invisible: !invalidUsername }"
            class="mt-1 text-fire text-xs italic"
          >
            Username not found.
          </p>
          <label
            class="mt-1 block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Password
            <input
              type="password"
              ref="password"
              class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
              :class="{ 'invalid-input': invalidPassword }"
              @input="invalidPassword = false"
              placeholder="***************"
              v-model="password"
            />
          </label>
          <p
            :class="{ invisible: !invalidPassword }"
            class="mt-1 text-red-500 text-xs italic"
          >
            Incorrect password.
          </p>

          <div class="flex flex-row justify-around mt-2">
            <button
              class="button focus:shadow-outline focus:outline-none"
              type="submit"
            >
              Sign In
            </button>
          </div>

          <div class="mt-4 text-center">
            <button
              type="button"
              @click="showResetModal = true"
              class="text-fire text-sm hover:text-red-700 underline focus:outline-none"
            >
              Forgot Password?
            </button>
          </div>
        </form>
      </div>
    </modal>

    <!-- Password Reset Modal -->
    <modal
      name="modal--password-reset"
      transition="nice-modal-fade"
      :click-to-close="false"
      :width="350"
      :height="'auto'"
    >
      <div
        class="flex flex-col font-degular text-black h-full bg-white overflow-hidden w-full justify-between p-4 rounded-lg"
      >
        <div class="text-center mb-4">
          <h3 class="text-lg font-bold text-gray-800">Reset Password</h3>
          <p class="text-sm text-gray-600 mt-2">
            Enter your email address and we'll send you a link to reset your
            password.
          </p>
        </div>

        <form @submit.prevent="handlePasswordReset" autocomplete="off">
          <label
            class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Email
            <input
              type="email"
              ref="resetEmail"
              class="text-base font-normal focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 mt-2"
              :class="{ 'invalid-input': invalidResetEmail }"
              @input="invalidResetEmail = false"
              placeholder="jill@seoulspice.com"
              v-model="resetEmail"
            />
          </label>
          <p
            :class="{ invisible: !invalidResetEmail }"
            class="mt-1 text-red-500 text-xs italic"
          >
            Please enter a valid email address.
          </p>
          <p
            :class="{ invisible: !resetEmailSent }"
            class="mt-1 text-green-600 text-xs italic"
          >
            Password reset email sent! Check your inbox.
          </p>

          <div class="flex flex-row justify-around mt-4">
            <button
              class="button focus:shadow-outline focus:outline-none"
              type="submit"
              :disabled="resetLoading"
            >
              {{ resetLoading ? 'Sending...' : 'Send Reset Email' }}
            </button>
          </div>

          <div class="mt-4 text-center">
            <button
              type="button"
              @click="closeResetModal"
              class="text-gray-600 text-sm hover:text-gray-800 underline focus:outline-none"
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>
``

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ModalLogin',
  data() {
    return {
      username: '',
      password: '',
      invalidUsername: false,
      invalidPassword: false,
      showResetModal: false,
      resetEmail: '',
      invalidResetEmail: false,
      resetEmailSent: false,
      resetLoading: false
    }
  },
  computed: {
    loading() {
      return this.$store.state.config.loading
    }
  },
  methods: {
    ...mapActions('user', ['login', 'sendPasswordResetEmail']),
    // beforeOpen: function() {
    //   this.$store.dispatch('config/setLoading', false)
    // },
    handleSubmit: async function () {
      if (!this.username.includes('@') || !this.username.includes('.com'))
        this.username = this.username + '@seoulspice.com'

      await this.login({
        email: this.username,
        password: this.password
      })
        .then(() => {
          this.username = this.password = ''
          this.$modal.hide('modal--login')
          this.$router.currentRoute &&
            this.$router.currentRoute.name &&
            this.$router.currentRoute.name !== 'dashboard' &&
            this.$router.replace({ name: 'dashboard' }) // push?
        })
        .catch((error) => {
          var errorCode = error.code
          var errorMessage = error.message
          if (errorCode === 'auth/wrong-password') {
            this.invalidPassword = true
            this.$refs.password.focus()
          } else if (
            errorCode === 'auth/invalid-email' ||
            errorCode === 'auth/user-not-found'
          ) {
            this.invalidUsername = true
            this.$refs.username.focus()
          } else {
            alert(errorMessage)
          }
        })
    },
    async handlePasswordReset() {
      this.resetLoading = true
      this.resetEmailSent = false
      this.invalidResetEmail = false

      // Validate email format
      if (
        !this.resetEmail ||
        !this.resetEmail.includes('@') ||
        !this.resetEmail.includes('.')
      ) {
        this.invalidResetEmail = true
        this.resetLoading = false
        this.$refs.resetEmail.focus()
        return
      }

      // Normalize email if needed
      if (!this.resetEmail.includes('@') || !this.resetEmail.includes('.com')) {
        this.resetEmail = this.resetEmail + '@seoulspice.com'
      }

      try {
        await this.sendPasswordResetEmail({ email: this.resetEmail })
        this.resetEmailSent = true
        this.resetEmail = ''

        // Auto-close modal after 3 seconds
        setTimeout(() => {
          this.closeResetModal()
        }, 3000)
      } catch (error) {
        const errorCode = error.code
        if (errorCode === 'auth/user-not-found') {
          this.invalidResetEmail = true
          this.$refs.resetEmail.focus()
        } else {
          alert('Error sending password reset email: ' + error.message)
        }
      } finally {
        this.resetLoading = false
      }
    },
    closeResetModal() {
      this.$modal.hide('modal--password-reset')
      this.showResetModal = false
      this.resetEmail = ''
      this.invalidResetEmail = false
      this.resetEmailSent = false
      this.resetLoading = false
    }
  },
  watch: {
    showResetModal(newVal) {
      if (newVal) {
        this.$modal.show('modal--password-reset')
      }
    }
  }
}
</script>

<style scoped>
input {
  transition: 0.5s all;
}
/* input:focus-within:not(.invalid-input) {
  @apply border-green-400;
} */
input:focus-within.invalid-input {
  border-color: rgb(248 113 113); /* equivalent to border-red-400 */
}
</style>
